import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCornerDownRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "transparent",
		d: "M12.4999 8.33301L16.6666 12.4997M16.6666 12.4997L12.4999 16.6663M16.6666 12.4997H6.66659C5.78253 12.4997 4.93468 12.1485 4.30956 11.5234C3.68444 10.8982 3.33325 10.0504 3.33325 9.16634V3.33301",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCornerDownRightArrow;
